import React from 'react';
import BasePrompt from '../base/prompt/BasePrompt';
import { gotoOutWeb } from '../../utils';

function RedirectToShopifyPrompt(props) {
  const show = props.show;
  const onHide = props.onHide || (() => {});
  const onConfirm = props.onConfirm || (() => {});
  const REACT_APP_SHOPIFY_DOMAIN =
  process.env.REACT_APP_SHOPIFY_DOMAIN || '';

  return (
    <BasePrompt
      show={show}
      closeAction={onHide}
      rightButton={{
        text: 'Send',
        action: () => {
          gotoOutWeb(
            REACT_APP_SHOPIFY_DOMAIN,
          ); //TODO: need to confirm this shopify link
          onConfirm();
        },
      }}
      leftButton={{
        text: 'Cancel',
        action: onHide,
      }}
      title={'Redirect to Products?'}
      description={
        'You have to go to Products to create online transaction records. Are you sure you to continue?'
      }
    />
  );
}

export default RedirectToShopifyPrompt;
